module.exports = __webpack_public_path__ + "static/media/Current-Balance.458859ce.svg";